/**
 * Created by mark on 05/03/2018.
 */


import React  from 'react';
import {Form , Row , Col   , Button} from 'react-bootstrap';
import FieldGroup from '../FieldGroup.js';
import validator from 'validator';
import Alert from '../alert.js';
import {AccountService} from '../../services';
import {Translation, AccountStore} from '../../store';
import Constants from '../../constants.js';
import Checkbox from '../checkbox.js';

export default class Establishment extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            countries:Translation.getCountriesList(),
            loaded:true
        };
    }

    renderPanelHeader(){
        return <div>
            <h1>{Translation.get(12654, 'Import Students')}</h1>
        </div>
    }

    save(){

        AccountService.update({
            name:this.state.name,
            billing_street:this.state.billing_address_street,
            post_code:this.state.billing_address_postalcode,
            office_email:this.state.general_enquiry_email,
            phone:this.state.general_enquiry_phone,
            billing_country:this.state.billing_address_country,
            urn:this.state.referance,
            billing_city:this.state.billing_address_city
        }).then(function(){
            this.setState({
                saved:true,
                updated:false,
                baseEmail:this.state.email,
            });
        }.bind(this))
    }

    componentDidMount(){
        AccountService.getInformation();
    }

    componentWillMount(){

        AccountStore.on(Constants.GET_ACCOUNT , ()=>{
            this.setState({
                loaded:true,
                "name": AccountStore.get().name,
                "billing_address_street" : AccountStore.get().street,
                "billing_address_postalcode" : AccountStore.get().post_code,
                "general_enquiry_email":AccountStore.get().email,
                "general_enquiry_phone":AccountStore.get().phone,
                "billing_address_country":AccountStore.get().billing_country,
                "billing_address_city":AccountStore.get().billing_city,
                "referance":AccountStore.get().unquie_referance
            });
        })
    }

    validate(id){

        switch(id)
        {
            case "name": return !validator.isEmpty(String(this.state.name));
            case "billing_address_street": return !validator.isEmpty(String(this.state.billing_address_street));
            case "billing_address_postalcode": return !validator.isEmpty(String(this.state.billing_address_postalcode));
            case "general_enquiry_email": {
                if (this.state.general_enquiry_email == undefined || this.state.general_enquiry_email == "") {
                    return true;
                }
                return validator.isEmail(String(this.state.general_enquiry_email))
            }
            case "general_enquiry_phone": return !validator.isEmpty(String(this.state.general_enquiry_phone));
        }

        return true;
    }



    render() {

        let options = [];

        for(var key in this.state.countries)
        {
            options.push(<option value={key} >{this.state.countries[key]}</option>);
        }


        let saved = null;

        if(!this.state.loaded) return <div style={{minHeight:"400px"}} className="fast animated fadeIn "></div>;
        if(this.state.saved){
            saved = <Alert  variant="success">{Translation.get(12655 , 'Your information has been updated')}</Alert>;
        }

        return <div>
                {saved}

                <Row>
                    <Col md={12}>
                        <FieldGroup value={this.state.name} state={!this.validate('name') ? "invalid" : ""} help={!this.validate('name') ? Translation.get(12782, "This can't be blank") : ""}  id="student-name" onChange={(event)=>{this.setState({saved:false, name:event.target.value, saved:false, updated:true})}} label="School name"/>
                    </Col>
                </Row>
            <Row>
                <Col md={6}>
                    <FieldGroup value={this.state.general_enquiry_phone} state={!this.validate('general_enquiry_phone') ? "invalid" : ""} help={!this.validate('general_enquiry_phone') ? Translation.get(12782, "This can't be blank") : ""} onChange={(event)=>{ this.setState({saved:false, general_enquiry_phone:event.target.value, saved:false, updated:true})} } id="office-phone" label="Office Phone"/>
                </Col>
                <Col md={6}>
                    <FieldGroup value={this.state.general_enquiry_email} state={!this.validate('general_enquiry_email') ? "invalid" : ""} help={!this.validate('general_enquiry_email') ? Translation.get(1033, "Invalid email") : ""} onChange={(event)=>{ this.setState({saved:false, general_enquiry_email:event.target.value, saved:false, updated:true})} } id="office-email" label="Office Email"/>
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <FieldGroup value={this.state.billing_address_street} state={""} help={!this.validate('billing_address_street') ? Translation.get(12782, "This can't be blank") : ""}  id="student-name" onChange={(event)=>{this.setState({saved:false, billing_address_street:event.target.value, saved:false, updated:true})}} label="Street"/>
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <FieldGroup value={this.state.billing_address_city} state={!this.validate('billing_address_city') ? "invalid" : ""} help={!this.validate('billing_address_city') ? Translation.get(12782, "This can't be blank") : ""}  id="student-name" onChange={(event)=>{this.setState({saved:false, billing_address_city:event.target.value, saved:false, updated:true})}} label="City"/>
                </Col>
            </Row>
            <Row>
                <Col md={6}>
                    <Form.Group controlId="exampleForm.ControlSelect1">
                        <Form.Label>Country</Form.Label>
                        <Form.Control value={this.state.billing_address_country}  onChange={(event)=>{ console.log(event.target.value); this.setState({saved:false, billing_address_country:event.target.value, saved:false, updated:true}) }} as="select">
                            {options}
                        </Form.Control>
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <FieldGroup value={this.state.billing_address_postalcode}  onChange={(event)=>{this.setState({saved:false, billing_address_postalcode:event.target.value, saved:false, updated:true})}} state={""} help={!this.validate('billing_address_postalcode') ? Translation.get(12782, "This can't be blank") : ""} label="Postcode"/>
                </Col>
            </Row>
            <Row>
                <Col md={{span:6 , offset:6}}>
                    <Button disabled={!this.state.updated} onClick={this.save.bind(this)}  className="float-right">{Translation.get(12658 ,'Update')}</Button>
                </Col>
            </Row>
        </div>
    
    }

}